import * as React from 'react';

import { CommonIconProps } from 'shared/entities/components/Icon';

import BaseIcon from '../BaseIcon';

const ClapperboardIcon: React.FC<CommonIconProps> = (
  props: CommonIconProps
) => {
  return (
    <BaseIcon
      {...props}
      proportion={48 / 44}
      svgProps={{
        viewBox: '0 0 48 44',
        fill: 'none'
      }}
    >
      <path
        d="M2 12h44V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v8z"
        fill="currentColor"
        fillOpacity="0.18"
      />
      <path
        d="M10 2l5 10M20 2l5 10M30 2l5 10M40 2l5 10"
        stroke="currentColor"
        strokeOpacity="0.35"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <rect
        x="2"
        y="12"
        width="44"
        height="30"
        rx="1"
        fill="currentColor"
        fillOpacity="0.1"
      />
      <rect
        x="8"
        y="20"
        width="20"
        height="2"
        rx="1"
        fill="currentColor"
        fillOpacity="0.15"
      />
      <rect
        x="8"
        y="26"
        width="14"
        height="2"
        rx="1"
        fill="currentColor"
        fillOpacity="0.15"
      />
      <rect
        x="8"
        y="32"
        width="10"
        height="2"
        rx="1"
        fill="currentColor"
        fillOpacity="0.15"
      />
    </BaseIcon>
  );
};

export default ClapperboardIcon;
